import React from 'react'

import { B2, Pressable, SH3, Stack } from '@zet/design-system'

type Props = {
  onPress: () => void
  timer: number
  onPressEventPayload: object
  timerOffText: string
  timerOnText: string
  disabled: boolean
}

const ResendWithTimer = ({
  onPress,
  timer,
  onPressEventPayload,
  timerOffText,
  timerOnText,
  disabled,
}: Props) => {
  return (
    <Stack className="mt-[20] items-center">
      {timer === 0 || disabled ? (
        <Pressable
          opacity={true}
          onPress={onPress}
          eventName="click_action"
          eventPayload={onPressEventPayload}
        >
          <SH3 className=" text-primary-100">{timerOffText}</SH3>
        </Pressable>
      ) : (
        <B2 className=" text-grays-60 text-center">
          {timerOnText}
          <SH3 className="text-primary-100">
            00:{timer < 10 ? `0${timer}` : timer}
          </SH3>
        </B2>
      )}
    </Stack>
  )
}

export default ResendWithTimer
